"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._AccelerateConfiguration = {
    type: "structure",
    required: [],
    members: {
        Status: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_AccelerateConfiguration.js.map